import React from 'react'

const Badges = ({ badgeLabels, setSelectedBadges, selectedBadges, value, onChange }) => {

    // Toggle badge selection
    const toggleBadgeSelection = (badge) => {

        const updatedSelectedBadges = selectedBadges.some(item => item._id === badge._id)
            ? selectedBadges.filter(item => item._id !== badge._id) // Deselect if already selected
            : [...selectedBadges, badge]; // Select if not selected

        // Update the selected badges state
        setSelectedBadges(updatedSelectedBadges);

        // Trigger the Formik onChange event to reflect the change
        onChange({
            target: { name: 'medical', value: updatedSelectedBadges }, // Ensure correct structure for Formik
        });
    };


    React.useEffect(() => {

        setSelectedBadges(value);

    }, [])

    return (
        <div className="flex flex-wrap gap-2">
            {badgeLabels.map((label, index) => (
                <span
                    key={index}
                    onClick={() => toggleBadgeSelection(label)}
                    className={`cursor-pointer h-[25px] leading-[16px] text-[12px] text-xs font-medium px-2.5 py-0.5 rounded border ${selectedBadges.some(badge => badge._id === label._id)
                        ? 'bg-[#007A63] text-white' // Selected styles
                        : 'bg-white text-[#525866] border-[#E2E4E9]'// Default styles
                        }`}
                >
                    {label.name}
                </span>
            ))}
        </div>
    )
}

export default Badges
